/**
 * Вибір рядків, як у провіднику ОС:
 *
 * - клік — лише цей рядок;
 * - Ctrl/Cmd — додати або прибрати рядок, решта лишається;
 * - Shift — діапазон від останнього «якоря» до цього рядка (з Ctrl — додається
 *   до вибраного, без Ctrl — замінює його).
 *
 * Якір — рядок останнього кліку без Shift. Порядок — як на екрані.
 */
export interface SelectionClick {
    ctrl: boolean
    shift: boolean
}

export interface SelectionState {
    selected: string[]
    anchor: string | null
}

export const nextSelection = (
    order: readonly string[],
    state: SelectionState,
    key: string,
    { ctrl, shift }: SelectionClick
): SelectionState => {
    if (shift && state.anchor !== null && order.includes(state.anchor)) {
        const from = order.indexOf(state.anchor)
        const to = order.indexOf(key)
        const range = order.slice(Math.min(from, to), Math.max(from, to) + 1)
        const selected = ctrl ? [...new Set([...state.selected, ...range])] : range

        return { selected, anchor: state.anchor }
    }

    if (ctrl) {
        const selected = state.selected.includes(key)
            ? state.selected.filter((item) => item !== key)
            : [...state.selected, key]

        return { selected, anchor: key }
    }

    return { selected: [key], anchor: key }
}
